import { defineMessages } from 'react-intl'

export default defineMessages({
  companyName: {
    defaultMessage: 'Företagsnamn',
    id: 'signup.form.company-name',
  },
  organizationNumber: {
    defaultMessage: 'Organisationsnummer',
    id: 'signup.form.organization-number',
  },
  contactInfo: {
    defaultMessage: 'Kontaktuppgifter',
    id: 'signup.form.contact-info',
  },
  createUser: {
    defaultMessage: 'Registrera en användare',
    id: 'signup.form.create-user',
  },
  createCompany: {
    defaultMessage: 'Skaffa gratis fakturering',
    id: 'signup.form.create-company',
  },
  createCompanyLede: {
    defaultMessage: 'Registrera ett konto och börja fakturera.',
    id: 'signup.form.create-company-lede',
  },
  email: {
    defaultMessage: 'E-postadress',
    id: 'signup.form.email',
  },
  errorEmail: {
    defaultMessage: 'Hoppsan, du måste ange en korrekt epostadress.',
    id: 'signup.form.error-email',
  },
  errorEmailMismatch: {
    defaultMessage:
      'Det valda personnummret är redan kopplat till en annan epostadress. Använd samma e-postadress som redan är kopplat till ditt personnummer. Du kan även logga in på ditt befintliga konto och ändra e-postadressen för din profil.',
    id: 'signup.form.error-email-mismatch',
  },
  cellPhone: {
    defaultMessage: 'Mobilnummer',
    id: 'signup.form.cellPhone',
  },
  errorCellPhone: {
    defaultMessage: 'Hoppsan, du måste ange ett korrekt telefonnummer.',
    id: 'signup.form.error-cell-phone',
  },
  errorIntegrity: {
    defaultMessage: 'Vi behöver ditt godkännande.',
    id: 'signup.form.error-integrity',
  },
  errorPersonnummer: {
    defaultMessage: 'Hoppsan, du måste ange ett korrekt personnummer.',
    id: 'signup.form.error-personnummer',
  },
  errorTermsOfService: {
    defaultMessage: 'Vi behöver ditt godkännande.',
    id: 'signup.form.error-terms-of-service',
  },
  errorText: {
    defaultMessage: 'Ojdå, det här måste du missat att fylla i.',
    id: 'signup.form.error-text',
  },
  errorShortCompanyName: {
    defaultMessage: 'Hoppsan, kontrollera att företagsnamnet är korrekt ifyllt. Du måste ange minst tre bokstäver.',
    id: 'signup.form.error-companyname',
  },
  errorOrganizationNumber: {
    defaultMessage: 'Hoppsan, du måste ange ett korrekt organisationsnummer.',
    id: 'signup.form.error-organisationsnummer',
  },
  firstName: {
    defaultMessage: 'Förnamn',
    id: 'signup.form.first-name',
  },
  integrity: {
    defaultMessage: 'Jag godkänner Dooers hantering av mina personuppgifter',
    id: 'signup.form.integrity',
  },
  lastName: {
    defaultMessage: 'Efternamn',
    id: 'signup.form.last-name',
  },
  noComittment: {
    defaultMessage: 'Du förbinder dig inte till någonting alls',
    id: 'signup.form.no-comittement',
  },
  allFeatures: {
    defaultMessage: 'Alla funktioner',
    id: 'signup.form.all-features',
  },
  oneOffer: {
    defaultMessage: "Du får en offert att utvärdera och godkänna<span class='hidden-xs'> i lugn och ro</span>",
    id: 'signup.form.offer',
  },
  unlimitedInvoices: {
    defaultMessage: 'Obegränsat antal fakturor',
    id: 'signup.form.unlimited-invoices',
  },
  unlimitedUsers: {
    defaultMessage: 'Obegränsat antal användare',
    id: 'signup.form.unlimited-users',
  },
  customLogo: {
    defaultMessage: 'Egen logotyp',
    id: 'signup.form.custom-logo',
  },
  webInvoice: {
    defaultMessage: 'Webbfaktura',
    id: 'signup.form.web-invoice',
  },
  free: {
    defaultMessage: 'Helt gratis',
    id: 'signup.form.free',
  },
  personnummer: {
    defaultMessage: 'Personnummer',
    id: 'signup.form.personnummer',
  },
  readMore: {
    defaultMessage: 'Läs mer >',
    id: 'signup.form.tos-readmore',
  },
  secure: {
    defaultMessage: 'Säker inloggning i Dooer',
    id: 'signup.form.secure',
  },
  signUpInfo: {
    defaultMessage:
      'Vi använder oss av mobil BankID-signering för att vara säkra på att ingen obehörig försöker företräda ditt bolag. Smart, smidigt och säkert.',
    id: 'signup.form.mobile-bank-info',
  },
  signUpInfoBilling: {
    defaultMessage: 'Skapa en användare för ditt företag och logga in med mobilt BankID. Smart, smidigt och säkert.',
    id: 'signup.form.mobile-bank-info-billing',
  },
  submit: {
    defaultMessage: 'Skapa konto och få offert',
    id: 'signup.form.submit',
  },
  submitShort: {
    defaultMessage: 'Skapa konto',
    id: 'signup.form.submit-short',
  },
  submitBilling: {
    defaultMessage: 'Logga in med mobilt BankID och börja fakturera',
    id: 'signup.form.submitBillingBankId',
  },
  submitBillingShort: {
    defaultMessage: 'Logga in & börja fakturera',
    id: 'signup.form.submitBilling',
  },
  termsOfService: {
    defaultMessage: 'Jag godkänner Dooers allmänna villkor',
    id: 'signup.form.terms-of-service',
  },
  youDecide: {
    defaultMessage: "Du bestämmer själv när du vill komma igång<span class='hidden-xs'> med bokföringen hos oss</span>",
    id: 'signup.form.you-decide',
  },
  otherService: {
    defaultMessage: 'Klar på 10 sekunder',
    id: 'signup.other-service',
  },
  unlimited: {
    defaultMessage: 'Helt obegränsat',
    id: 'signup.unlimited',
  },
})
